module.exports = __webpack_public_path__ + "img/kuaishou3s.c8b7120d.png";